module.exports = __webpack_public_path__ + "static/media/edit.202c7365.svg";